import React, { useState } from 'react';
import api from '../../api/api';
import { useAuth } from '../../contexts/AuthContext';
import { Card, Input, Button } from '../../components/ui';

export default function AccountingTreasuryPost() {
  const { accountingEnabled } = useAuth();
  const [txId, setTxId] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const handlePost = async () => {
    if (!txId) return;
    setLoading(true);
    setError(null);
    setResult(null);
    try {
      const res = await api.post(`/accounting/post/treasury-transaction/${txId}`);
      setResult(res.data);
    } catch (e) {
      setError(e.response?.data?.error || e.message);
    } finally {
      setLoading(false);
    }
  };

  if (!accountingEnabled) {
    return (
      <div className="min-h-screen bg-gray-50 p-6">
        <div className="max-w-3xl mx-auto">
          <Card>
            <h1 className="text-xl font-bold text-gray-900 mb-2">Trésorerie → Écritures</h1>
            <p className="text-gray-600">Module désactivé.</p>
          </Card>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-3xl mx-auto space-y-4">
        <Card>
          <h1 className="text-xl font-bold text-gray-900">Trésorerie → Écritures</h1>
          <p className="text-gray-600 text-sm">Poster une transaction de trésorerie en écriture comptable.</p>
        </Card>

        <Card>
          <div className="flex gap-3">
            <Input
              value={txId}
              onChange={(e) => setTxId(e.target.value)}
              placeholder="ID transaction trésorerie (Mongo ObjectId)"
              className="flex-1"
            />
            <Button
              onClick={handlePost}
              disabled={loading || !txId}
            >
              {loading ? 'Posting...' : 'Poster'}
            </Button>
          </div>
        </Card>

        {error && <div className="p-3 bg-red-50 border border-red-100 text-red-700 rounded-lg">{error}</div>}
        {result && (
          <pre className="p-3 bg-gray-50 border rounded-lg text-xs overflow-auto">
            {JSON.stringify(result, null, 2)}
          </pre>
        )}
      </div>
    </div>
  );
}
